import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";
import {AuditScoreBadge} from "@/pages/pagespeed/report/body/AuditScoreBadge.tsx";
import {removeLinksFromMarkdown} from "@/pages/pagespeed/report/body/legacyHelpers.tsx";
import {LHRAudit} from "@/pages/pagespeed/types.ts";

interface SingleMetricProps {
  audit: LHRAudit;
}

export const SingleMetric = ({audit}: SingleMetricProps) => (
  <div className="audit p-3 d-flex align-items-center">
    {audit.score && <div className="audit-score-badge mr-3">{<AuditScoreBadge audit={audit} />}</div>}
    <div>
      <div className="label label-sm">
        <span>{audit.title}</span>
        <TooltipIconRA
          className={"ms-1"}
          title={removeLinksFromMarkdown(audit.description)}
          iconProps={{
            display: "inline",
            removeDivDimensions: true,
          }}
        />
      </div>
      <div className="value">{audit.displayValue}</div>
    </div>
  </div>
);
